import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, SidebarModal, Text,
} from '@domain-group/suit-theme'

const ModalSubheader = (props) => {
  const { subTitle, ownerTitle, title } = props

  return (
    <SidebarModal.SubHeader>
      <Box boxProps={{ lineHeight: 1.3 }} flexDirection="column">
        <Text color="bodyFontLightColor" fontSize="small">{title}</Text>

        <Text marginTop={subTitle ? 'large' : 'medium'}>{ownerTitle}</Text>

        {subTitle && <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">{subTitle}</Text>}
      </Box>
    </SidebarModal.SubHeader>
  )
}

ModalSubheader.propTypes = {
  ownerTitle: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default ModalSubheader
